export const SET_COUNTRY_LIST = 'login/set_country_list';//返回国家信息列表
export const GET_COUNTRY_LIST = 'login/get_country_list';//获取国家信息列表
//异步调用错误
export const LOGIN_NETWORK_ERROR='login/NETWORK_ERROR';
